import DefaultProgress from "./default-progress";

export default { DefaultProgress };
